// extracted by mini-css-extract-plugin
module.exports = {"textEndOfResults":"PageExploreArtists_textEndOfResults__38Gy9","title":"PageExploreArtists_title__Y167N"};